import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
/**
 * 假日出行
 * @type {{userInfo: {}}}
 */

var state = {
  activeComponent: 'chat',
  // 标识会话或历史['chat','history']
  topBarHeight: 44,
  // 顶部高度
  aiLoading: false,
  // ai是否正在加载
  aiChatList: [],
  // ai会话数据
  guideQuestionList: [],
  // 初始化窗口引导问题
  qaId: '',
  // 当前操作自动生成的ID
  reloadHandler: {
    // 是否重新生成答案
    isReload: false,
    data: {}
  },
  sendHandler: {
    // 发送,监听send,如果为true,则发送消息
    send: false,
    message: ''
  }
};
var getters = {
  activeComponent: function activeComponent(state) {
    return state.activeComponent;
  },
  topBarHeight: function topBarHeight(state) {
    return state.topBarHeight;
  },
  aiLoading: function aiLoading(state) {
    return state.aiLoading;
  },
  aiChatList: function aiChatList(state) {
    return state.aiChatList;
  },
  guideQuestionList: function guideQuestionList(state) {
    return state.guideQuestionList;
  },
  qaId: function qaId(state) {
    return state.qaId;
  },
  sendHandler: function sendHandler(state) {
    return state.sendHandler;
  },
  reloadHandler: function reloadHandler(state) {
    return state.reloadHandler;
  }
};
var mutations = {
  SET_VALUE: function SET_VALUE(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    state[key] = value;
  },
  RESET: function RESET(state) {
    state.activeComponent = 'chat';
    state.topBarHeight = 44;
    state.aiLoading = false;
    state.aiChatList = [];
    state.guideQuestionList = [];
    state.qaId = '';
  }
};
var actions = {
  setValue: function setValue(_ref2, _ref3) {
    var commit = _ref2.commit;
    var key = _ref3.key,
      value = _ref3.value;
    if (!key) {
      throw new Error('key in not null');
    }
    commit('SET_VALUE', {
      key: key,
      value: value
    });
  },
  /**
   * 重置
   * @param commit
   */
  reset: function reset(_ref4) {
    var commit = _ref4.commit;
    commit('RESET');
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};